module.exports = __webpack_public_path__ + "img/Edelstahlhandlauf.4dbbbcfe.jpg";